"use client";

import { useEffect } from "react";
import type { User } from "openapi/api/model";
import { clearSentryIdentity, setSentryIdentityFromUser } from "@/observability/sentry-identity";

export const useSentryIdentity = (user: User | undefined): void => {
  useEffect(() => {
    if (!user) {
      clearSentryIdentity();
      return;
    }

    setSentryIdentityFromUser(user);
  }, [user]);
};
